"use client";

const _excluded = ["size"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
import React from "react";
import BaseIcon from "../../utils/BaseIcon";
const TickInCircleSystemIcon = props => {
  const {
      size = 24
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  const iconFill = "currentColor";
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    size: size
  }, otherProps, {
    "data-mesh-component": "TICK-IN-CIRCLE-SYSTEM-ICON"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: iconFill,
    fillRule: "nonzero",
    d: "M12.025 23.892c6.558 0 11.875-5.317 11.875-11.876C23.9 5.457 18.583.14 12.025.14 5.465.14.149 5.457.149 12.016c0 6.559 5.317 11.876 11.876 11.876m0-1.5c-5.73 0-10.376-4.646-10.376-10.376 0-5.73 4.645-10.376 10.376-10.376 5.73 0 10.375 4.645 10.375 10.376 0 5.73-4.645 10.376-10.375 10.376m-1.227-5.357 7.477-8.91a.75.75 0 0 0-1.15-.965l-6.92 8.248-3.344-3.73a.75.75 0 0 0-1.117 1l3.92 4.376a.75.75 0 0 0 1.134-.019"
  })));
};
TickInCircleSystemIcon.displayName = "TickInCircleSystemIcon";
TickInCircleSystemIcon.iconName = "TickInCircle";
export default TickInCircleSystemIcon;